export default "__VITE_ASSET__CO62Cb_C__"